import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CiiBadgeComponent } from '../../components/cii-badge/cii-badge.component';

@Component({
  selector: 'app-modernisation',
  standalone: true,
  imports: [RouterLink, CiiBadgeComponent],
  templateUrl: './modernisation.component.html',
  styleUrl: './modernisation.component.css'
})
export class ModernisationComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Audit de Code & Modernisation Legacy Node.js / Angular — Expert CII");
    this.metaService.updateTag({ name: 'description', content: "Réduisez votre dette technique. Audit de code, refonte et migration AngularJS vers Angular moderne. Agence agréée CII pour sécuriser votre patrimoine logiciel." });
  }
}